module.exports = __webpack_public_path__ + "static/img/406.36f4ce2.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/406.png
// module id = 525
// module chunks = 3